import { useTranslation } from 'react-i18next';

import { Flex } from '@percent/lemonade';
import { Card, OrganisationPreview } from '@percent/hosted-validation-form/ui';
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData';
import { HostedFormStep } from '../../HostedForm.types';
import { usePartnerConfig, useProgress } from '@percent/hosted-validation-form/hooks';

export const OrganisationResult = () => {
  const { organisation, handleBack, handleNext } = useValidationStepData();
  const { partnerConfig } = usePartnerConfig();
  const { progress } = useProgress();
  const { t } = useTranslation();

  const handleNavigateNext = () => {
    if (organisation?.website) {
      if (
        partnerConfig?.configuration.avCheckAvailable !== undefined &&
        !partnerConfig?.configuration.avCheckAvailable
      ) {
        const hasPartnerFields = !!partnerConfig?.configuration?.partnerFields?.length;
        if (hasPartnerFields) {
          return handleNext(HostedFormStep.PARTNER_FIELDS);
        }
        return handleNext(HostedFormStep.TERMS);
      } else {
        return handleNext(HostedFormStep.CONTACT_DETAILS);
      }
    } else {
      return handleNext(HostedFormStep.WEBSITE);
    }
  };

  return (
    <Card
      onBack={handleBack}
      onNext={handleNavigateNext}
      nextButtonLabel={t('hostedValidation.button.next')}
      title={t('hostedValidation.title.isThisNonprofit')}
      progress={progress}
    >
      <Flex direction="column" gap={16} w="100%">
        {organisation && <OrganisationPreview organisation={organisation} />}
      </Flex>
    </Card>
  );
};
